(() => {
  const updateCartCount = (count) => {
    if (!Number.isFinite(count)) return;

    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
    });
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const count = cart?.totalQuantity ?? detail?.itemCount;
        updateCartCount(count);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[volt-cart-count] Cart update failed:', error);
      });
  });
})();
